import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
function createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics) {
  return {
    singleInstrumentationID: interactionID !== null && interactionID !== void 0 ? interactionID : '',
    aiInteractionID: interactionID !== null && interactionID !== void 0 ? interactionID : '',
    aiFeatureName: 'Editor AI',
    aiExperienceName: experienceName !== null && experienceName !== void 0 ? experienceName : 'unknown',
    isAIFeature: 1,
    proactiveAIGenerated: !!isProactive ? 1 : 0,
    userGeneratedAI: !isProactive ? 1 : 0,
    traceIds: traceIds,
    invokedFrom: invokedFrom,
    nudgeMetrics: nudgeMetrics
  };
}

/**
 * Utility types to extract only the non-common attributes
 * * OmitCommonAttributes: Removes AIUnifiedCommonAttributes from the unified attributes
 *   * We also distribute the Omit across the union
 * * ExcludeEmpty: Editor Common AEP Utilities also extends attributes with & {}
 *   * {} allows any properties to be added
 *   * We are also sometimes left with {} after using Omit
 *   * This util drops any {} types from the union
 */

export function createUnifiedAnalyticsPayload(_ref) {
  var action = _ref.action,
    interactionID = _ref.interactionID,
    attributes = _ref.attributes,
    experienceName = _ref.experienceName,
    isProactive = _ref.isProactive,
    invokedFrom = _ref.invokedFrom,
    traceIds = _ref.traceIds,
    nudgeMetrics = _ref.nudgeMetrics;
  var unifiedAnalyticsAttributes = createAIUnifiedCommonAttributes(interactionID, experienceName, isProactive, traceIds, invokedFrom, nudgeMetrics);
  switch (action) {
    case ACTION.ACTIONED:
      {
        return {
          action: action,
          actionSubject: ACTION_SUBJECT.AI_RESULT,
          actionSubjectId: ACTION_SUBJECT_ID.EDITOR_PLUGIN_AI,
          eventType: EVENT_TYPE.TRACK,
          attributes: _objectSpread(_objectSpread({
            aiResultAction: 'unknown'
          }, unifiedAnalyticsAttributes), attributes)
        };
      }
    case ACTION.VIEWED:
    case ACTION.ERROR:
      {
        return {
          action: action,
          actionSubject: ACTION_SUBJECT.AI_RESULT,
          actionSubjectId: ACTION_SUBJECT_ID.EDITOR_PLUGIN_AI,
          eventType: EVENT_TYPE.TRACK,
          attributes: _objectSpread(_objectSpread({}, unifiedAnalyticsAttributes), attributes)
        };
      }
    case ACTION.INITIATED:
    case ACTION.DISMISSED:
      {
        return {
          action: action,
          actionSubject: ACTION_SUBJECT.AI_INTERACTION,
          actionSubjectId: ACTION_SUBJECT_ID.EDITOR_PLUGIN_AI,
          eventType: EVENT_TYPE.TRACK,
          attributes: _objectSpread(_objectSpread({}, unifiedAnalyticsAttributes), attributes)
        };
      }
    case ACTION.SUBMITTED:
      {
        return {
          action: action,
          actionSubject: ACTION_SUBJECT.AI_FEEDBACK,
          actionSubjectId: ACTION_SUBJECT_ID.EDITOR_PLUGIN_AI,
          eventType: EVENT_TYPE.TRACK,
          attributes: _objectSpread(_objectSpread({
            // If feedback result is not explicitly set then we should assume negative, since people are more likely to
            // report negative experiences than they are positive ones.
            aiFeedbackResult: 'down'
          }, unifiedAnalyticsAttributes), attributes)
        };
      }
  }
}